module.exports = __webpack_public_path__ + "static/img/64-2.1f3c3c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/64-2.jpg
// module id = RzMH
// module chunks = 0